export default __webpack_public_path__ + "static/h&m.url-b49a9a997edcc888491d121345e10b21.svg";